<template>

    <div class="panel">
      <div class="panel-heading tw-h-min md:tw-h-[50px] tw-flex tw-flex-col md:tw-flex-row tw-items-center">
        <span class="panel-icon">
          <slot name="icon"></slot>
        </span>
        <span class="panel-title">
          <slot name="title"></slot>
        </span>
        <span class="panel-controls tw-ml-auto tw-mb-4 md:tw-mb-0 tw-flex tw-items-center">
          <slot name="controls"></slot>
        </span>
      </div>
      <div class="panel-body tw-w-full">
        <slot></slot>
      </div>
    </div>

</template>

<script>
export default {

};
</script>
